import { render } from "./EventImageBackgrounds.vue?vue&type=template&id=2c116c6e"
import script from "./EventImageBackgrounds.vue?vue&type=script&lang=js"
export * from "./EventImageBackgrounds.vue?vue&type=script&lang=js"

import "./EventImageBackgrounds.vue?vue&type=style&index=0&id=2c116c6e&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__